var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({attrs:{"color":_vm.color}},'v-btn',_vm.$attrs,false),_vm.$listeners),[(_vm.icon)?_c('v-icon',{staticClass:"mr-2"},[_vm._v("\n    "+_vm._s(_vm.icon)+"\n  ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"text-none"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }